import React from "react";
import Newsletter_43 from "../component/Newsletter_43";

function Newsletter_43_container() {
  return <Newsletter_43 />;
}

export default Newsletter_43_container;
